import { render } from "./ImgMenuSet.vue?vue&type=template&id=7a3d3fc8&scoped=true"
import script from "./ImgMenuSet.vue?vue&type=script&lang=js"
export * from "./ImgMenuSet.vue?vue&type=script&lang=js"

import "./ImgMenuSet.vue?vue&type=style&index=0&id=7a3d3fc8&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3d3fc8"]])

export default __exports__